import { useState } from "react";
import { setEventOnsiteRegistration } from "../../api/events";
import ErrorAlert from "../ErrorAlert/ErrorAlert";
import { getUserFacingErrorMessage } from "../../utils/userFacingError";

type Props = {
  eventId: number;
  enabled: boolean;
  onUpdated?: (enabled: boolean) => void;
};

export default function OnsiteRegistrationControl({
  eventId,
  enabled,
  onUpdated,
}: Props) {
  const [value, setValue] = useState(enabled);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleToggle() {
    setError(null);
    setIsSaving(true);
    const previous = value;
    const next = !value;
    setValue(next);
    try {
      const event = await setEventOnsiteRegistration(eventId, next);
      onUpdated?.(event.onsiteRegistrationOpen);
    } catch (err) {
      setValue(previous);
      setError(
        getUserFacingErrorMessage(
          err,
          "Could not update on-site registration.",
        ),
      );
    } finally {
      setIsSaving(false);
    }
  }

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-3">
        <button
          type="button"
          className="eh-btn-secondary text-sm px-4 py-2"
          disabled={isSaving}
          onClick={handleToggle}
        >
          {isSaving
            ? "Updating…"
            : value
              ? "Close on-site registration"
              : "Open registration for on-site price"}
        </button>
        <span
          className={`text-xs font-medium px-2 py-0.5 rounded-sm ${
            value
              ? "bg-green-50 text-green-800 border border-green-200"
              : "bg-slate-100 text-slate-600 border border-slate-200"
          }`}
        >
          {value ? "On-site registration open" : "On-site registration closed"}
        </span>
      </div>
      {error && <ErrorAlert inline>{error}</ErrorAlert>}
    </div>
  );
}
